import React from "react";
import { TreeSelect } from "antd";

interface IBasicFolderTreeProps {
  treeData: Array<Object>;
  value?: any;
  onChange?(value: any): () => void;
  onTreeSelect(value, option): void;
}

interface IBasicFolderTreeState {}

export default class BasicFolderTree extends React.Component<
  IBasicFolderTreeProps,
  IBasicFolderTreeState
> {
  triggerChange = (changedValue) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(changedValue);
    }
  };

  onTreeChange = (value: any) => {
    this.triggerChange(value);
  };

  onBasicTreeSelect = (value, option) => {
    console.log(value, option);
    this.props.onTreeSelect(value, option);
  };

  render() {
    const { treeData, value } = this.props;
    return (
      <TreeSelect
        showSearch
        showArrow={false}
        style={{ width: "100%" }}
        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
        placeholder="请选择父文件夹"
        treeDefaultExpandedKeys={[value]}
        allowClear
        treeDefaultExpandAll={false}
        onChange={this.onTreeChange}
        onSelect={this.onBasicTreeSelect}
        treeData={treeData}
        value={value}
      />
    );
  }
}
